import React from 'react';
import ContentLoader from 'react-content-loader';

const TitleLoader = () => (
  <ContentLoader
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    height={12}
    speed={2}
    viewBox="0 0 470 12"
    width={470}>
    <rect height="12" rx="6" ry="6" width="470" x="0" y="0" />
  </ContentLoader>
);

export default TitleLoader;
